export const SET_ANNOUNCEMENTS_BEING_SHOWN = "SET_ANNOUNCEMENTS_BEING_SHOWN";
